import { AppUtils } from './../../utils/app.utils';
import { ConfigService } from '@services/webFeeder/config.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dictionary-error',
  templateUrl: './dictionary-error.component.html'
})
export class DictionaryErrorComponent implements OnInit {

  public listErrorSystem: any = [];

  constructor(
    public _configService: ConfigService
  ) {
    this.listErrorSystem = this._configService.getDictionaryError();
    AppUtils.orderObjectAsc(this.listErrorSystem, 'cod');
  }

  ngOnInit() {
  }

}
